export { default as SelectedMaterialsSidebar } from './SelectedMaterialsSidebar';
